import {useTranslation} from "react-i18next";
import clsx from "clsx";
import PropTypes from "prop-types";

import "./Title.scss";

const Title = ({number = null, text, className, colon = true}) => {
  const {t} = useTranslation();
  return (
    <h3 className={clsx("title_styles", className)}>
      {number != null && <span>{number}. </span>}
      {t(text)}
      {colon && text ? ":" : ""}
    </h3>
  );
};
Title.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
  number: PropTypes.number,
};
export default Title;
